import { Injectable } from '@angular/core';
import { UserDefaults } from './';

@Injectable()
export class LocalStorageService {
  static readonly LOCALSTORAGE_APP_IDENTIFIER = 'txtApp';

  constructor() { }

  public loadUserDefaults(username: string): UserDefaults {
    const key = LocalStorageService.LOCALSTORAGE_APP_IDENTIFIER + '.' + username + '.UserDefaults';
    const value = localStorage.getItem(key);
    if (value) {
      return JSON.parse(value) as UserDefaults;
    }

    return {} as UserDefaults;
  }

  public saveUserDefaults(username: string, defaults: UserDefaults): void {
    const key = LocalStorageService.LOCALSTORAGE_APP_IDENTIFIER + '.' + username + '.UserDefaults';

    localStorage.setItem(key, JSON.stringify(defaults));
  }

}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/services/local-storage.service.ts